import * as THREE from "three";
import LayerMappingsEnum from "../../enums/LayerMappingsEnum";
import { setLayerToGroupAndChildren, setVisibilityToGroupAndChildren } from "../../utils/groupUtils"
import ISceneGeometry from "../sceneObject/ISceneGeometry";
import LengthDimensionData from "../sceneObjectData/LengthDimensionData";
import SceneObjectData from "../sceneObjectData/SceneObjectData";
import CompoundSceneGeometry from "./CompoundSceneGeometry";
import LengthDimensionSubGeometry2d from "./LengthDimensionSubGeometry2d";
import LengthDimensionSubGeometry3d from "./LengthDimensionSubGeometry3d";
import { tolerances } from "../../utils/constants";

export default class LengthDimensionCompoundGeometry extends CompoundSceneGeometry<LengthDimensionData> {

    geometry2d: LengthDimensionSubGeometry2d = new LengthDimensionSubGeometry2d();
    geometry3d: LengthDimensionSubGeometry3d = new LengthDimensionSubGeometry3d();
    
    constructor() {
        super();

        this.group.add(this.geometry2d.group);
        this.group.add(this.geometry3d.group);

        /* this.geometry2d.setLayer(LayerMappingsEnum.Annotations2d);
        this.geometry3d.setLayer(LayerMappingsEnum.Annotations3d); */
    }

    protected getSubGeometries() : ISceneGeometry[] {
        return [this.geometry2d, this.geometry3d];
    }

    onAnnotationDirectionChange(rotationOffset: number): void {
        this.geometry2d.onAnnotationDirectionChange(rotationOffset);
        this.geometry3d.onAnnotationDirectionChange(rotationOffset);
    }

    protected updateGeometry(data: SceneObjectData, forceUpdate: boolean): boolean {
        const lengthData = data as LengthDimensionData;
        const result = super.updateGeometry(lengthData, forceUpdate);

        this.geometry2d.setLayer(LayerMappingsEnum.Annotations2d);
        this.geometry3d.setLayer(LayerMappingsEnum.Annotations3d);
        
        // Show 2d geometry only if needed
        if ( this.isVisibleIn2d(lengthData)) { this.geometry2d.show(); }
        else { this.geometry2d.hide(); }

        return result;
    }

    private isVisibleIn2d(data: LengthDimensionData) : boolean {
        if (data.offset.lengthSq() < tolerances.position) 
            return true;

        const planeNormal = new THREE.Plane().setFromCoplanarPoints(data.start, data.end, data.end.clone().add(data.offset)).normal;
        const diff = 1 - Math.abs(new THREE.Vector3(0,0,1).dot(planeNormal));
        return  diff < tolerances.directionAngle; // More than 45 degrees to Z axis
    }
};
